import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Monitor, Moon, Sun } from "lucide-react";
import { applyTheme, nextTheme, storedTheme, type Theme } from "../lib/theme";

const ICONS: Record<Theme, typeof Sun> = { system: Monitor, light: Sun, dark: Moon };

export function ThemeToggle() {
  const { t } = useTranslation();
  const [theme, setTheme] = useState<Theme>(() => storedTheme());
  const Icon = ICONS[theme];
  const label = `${t("theme.toggle")}: ${t("theme." + theme)}`;
  return (
    <button
      type="button"
      className="btn-icon"
      aria-label={label}
      title={label}
      onClick={() => {
        const n = nextTheme(theme);
        applyTheme(n);
        setTheme(n);
      }}
    >
      <Icon size={18} aria-hidden />
    </button>
  );
}
